module.exports = __webpack_public_path__ + "static/media/mnist_2.db843669.jpg";